/**
 * Fields written to `users/{uid}` when a coach saves Basic Info from the console.
 * - Unregistered clients: `email` + `coachContactEmail` stay in sync (legacy + contact).
 * - Registered clients: only `coachContactEmail` is updated so we never overwrite the
 *   Auth-linked `email` / `authLoginEmail` used for sign-in.
 */
export function coachUserUpdateFromBasicInfo(client, data) {
  const base = {
    firstName: data.firstName,
    lastName: data.lastName,
  };
  if (client?.authId) {
    return { ...base, coachContactEmail: data.email || "" };
  }
  return {
    ...base,
    email: data.email || "",
    coachContactEmail: data.email || "",
  };
}
